export class SelectListItem {
  constructor(public value: string | number | boolean, public text: string) {}
}

export class SelectList {
  isEnabled: (
    x: any // eslint-disable-line @typescript-eslint/no-explicit-any
  ) => boolean;
  static mapFromAny(
    data: any[], // eslint-disable-line @typescript-eslint/no-explicit-any
    propValue: string = 'Key',
    propText: string = 'Value'
  ) {
    const sl = new SelectList([]);

    for (const item of data) {
      const sli = new SelectListItem(item[propValue], item[propText]);
      sl.items.push(sli);
    }

    return sl;
  }

  constructor(public items: SelectListItem[] = []) {
    this.isEnabled = x => {
      // eslint-disable-next-line
      return this.items.find(z => z.text === x)!.value as boolean;
    };
  }
}
